import {
  collection,
  deleteDoc,
  doc,
  getDocs,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  startAfter,
  limit,
  setDoc,
  type Unsubscribe,
  type DocumentData,
  type QueryDocumentSnapshot,
} from "firebase/firestore";
import { db } from "./firebase";
import type { SavedImage, SavedImageDoc } from "../types/saved";

export function savedImageDocId(imagePath: string): string {
  return imagePath.replace(/[/.]/g, "_");
}

export async function saveImage(
  uid: string,
  imagePath: string,
  jobId: string,
): Promise<void> {
  const ref = doc(db, "users", uid, "savedImages", savedImageDocId(imagePath));
  await setDoc(
    ref,
    {
      imagePath,
      jobId,
      createdAt: serverTimestamp(),
    },
    { merge: true },
  );
}

export async function removeSavedImage(uid: string, imagePath: string): Promise<void> {
  const ref = doc(db, "users", uid, "savedImages", savedImageDocId(imagePath));
  await deleteDoc(ref);
}

export async function fetchSavedImagesPage(
  uid: string,
  pageSize = 8,
  cursor?: QueryDocumentSnapshot<DocumentData> | null,
): Promise<{ items: SavedImage[]; lastDoc: QueryDocumentSnapshot<DocumentData> | null }> {
  const savedRef = collection(db, "users", uid, "savedImages");
  const baseQuery = query(savedRef, orderBy("createdAt", "desc"));
  const pagedQuery = cursor
    ? query(baseQuery, startAfter(cursor), limit(pageSize))
    : query(baseQuery, limit(pageSize));
  const snapshot = await getDocs(pagedQuery);
  const items = snapshot.docs.map((docSnap) => ({
    id: docSnap.id,
    ...(docSnap.data() as SavedImageDoc),
  }));
  const lastDoc =
    snapshot.docs.length > 0 ? snapshot.docs[snapshot.docs.length - 1] : null;
  return { items, lastDoc };
}

export function subscribeSavedImages(
  uid: string,
  onUpdate: (items: SavedImage[]) => void,
): Unsubscribe {
  const savedRef = collection(db, "users", uid, "savedImages");
  const q = query(savedRef, orderBy("createdAt", "desc"));
  return onSnapshot(q, (snapshot) => {
    const items = snapshot.docs.map((docSnap) => ({
      id: docSnap.id,
      ...(docSnap.data() as SavedImageDoc),
    }));
    onUpdate(items);
  });
}
